import { checkIfAllInstancesOfVariantAddedToCart } from '../cart/updateATCButton';

if (!customElements.get('variant-selector')) {
  class VariantSelector extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('change', this.onVariantChange);

      this.sectionId = this.dataset.section;
      this.datasetUrl = this.dataset.url;

      this.availablePartnerLocations = [];

      this.mediaGallery = document.querySelector('[data-media-gallery-id]');

      if (this.mediaGallery) {
        this.mediaGallerySectionId = this.mediaGallery.dataset.mediaGalleryId;
        this.swiperEl = this.mediaGallery.querySelector('.swiper:not([thumbsSlider])');
      }

      this.productForm = document.getElementById(`product-form-${this.sectionId}`);
      this.productFormSection = document.getElementById(`shopify-section-${this.sectionId}`);

      this.init();
    }

    init() {
      this.getSelectedOptions();
      this.getSelectedVariant();
      this.updateVariantStatuses();

      if (this.currentVariant) {
        this.fetchPartnerStoresAvailability();
        this.currentVariantId = this.currentVariant.id;
        this.fetchAvailability();
      }
    }

    fetchPartnerStoresAvailability() {
      // remove last part of the sku to get the parent sku
      const parentSku = this.currentVariant.sku;
      if (!parentSku) return;
      const parentSkus = parentSku.split('.').slice(0, -1).join('.');
      const partnerStores = JSON.parse(document.querySelector('#partner-stores').textContent);

      const mappedPartnerStores = partnerStores.map((item) => ({
        available: 0,
        name: item['Navn'],
        address: {
          address1: item['Adresse'],
          address2: item['Adresse2'],
          city: item['By'],
          phone: item['Telefon'].toString(),
          zip: item['Postnr.'].toString(),
        },
        store_id: item['Butiksnr.'].toString(),
        reserve_item: item['RESERVE'] === 'Yes' ? 'true' : 'false',
        email: item['EMAIL'],
      }));

      const _this = this;
      const SHOPIFY_APP_PROXY_LOGIN_URL = 'https://function-bun-production-99a1.up.railway.app';

      fetch(`${SHOPIFY_APP_PROXY_LOGIN_URL}/fetch-int-service-data`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ endpoint: `/intersport/get-partner-stores-stock`, method: "POST", payload: { skus: parentSkus } }),
      })
        .then((response) => response.json())
        .then((stockInfo) => {
          const availableLocations = [];
          console.log(stockInfo);

          if (!stockInfo.products || !stockInfo.products.length) return;

          for (const variant of stockInfo.products) {
            if (availableLocations.filter((location) => location.sku === variant.sku).length === 0) {
              availableLocations.push({ sku: variant.sku, stores: [] });
            }
          }

          for (const store of mappedPartnerStores) {
            for (const variant of stockInfo.products) {
              if (store.store_id === variant.shopifyLocationId) {
                store.available = variant.quantity;
                store.sku = variant.sku;
                availableLocations.find((location) => location.sku === variant.sku).stores.push(store);
              }
            }
          }

          _this.availablePartnerLocations = availableLocations;
        });
    }

    onVariantChange() {
      this.getSelectedOptions();
      this.getSelectedVariant();
      this.updateVariantStatuses();

      if (this.currentVariant) {
        this.currentVariantId = this.currentVariant.id;
        this.updateURL();
        this.updateFormID();
        this.getSectionContent();
        this.fetchAvailability();
        this.updateMedia();
        this.updateGalleryLabels();
      }

      const event = new Event('variant-changed');
      this.dispatchEvent(event);
    }

    getSelectedOptions() {
      this.productFormSection.classList.add('section-loading');

      const fieldsets = Array.from(this.querySelectorAll('fieldset'));
      this.options = fieldsets.map((fieldset) => {
        return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
      });
    }

    updateVariantStatuses() {
      const selectedOptionOneVariants = this.variantData.filter((variant) => this.querySelector(':checked').value === variant.option1);
      const inputWrappers = [...this.querySelectorAll('fieldset')];
      inputWrappers.forEach((option, index) => {
        if (index === 0) return;
        const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
        const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
        const availableOptionInputsValue = selectedOptionOneVariants.filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected).map((variantOption) => variantOption[`option${index + 1}`]);
        this.setInputAvailability(optionInputs, availableOptionInputsValue);
      });
    }

    setInputAvailability(listOfOptions, listOfAvailableOptions) {
      listOfOptions.forEach((input) => {
        if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
          input.classList.remove('disabled');
        } else {
          input.classList.add('disabled');
        }
      });
    }

    getVariantJSON() {
      this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
      return this.variantData;
    }

    getSelectedVariant() {
      this.currentVariant = this.getVariantJSON().find((variant) => {
        const findings = !variant.options
          .map((option, index) => {
            return this.options[index] === option;
          })
          .includes(false);
        if (findings) return variant;
      });
      return this.currentVariant;
    }

    updateURL() {
      if (!this.currentVariant) return;
      window.history.replaceState({}, '', `${this.datasetUrl}?variant=${this.currentVariantId}`);
    }

    updateFormID() {
      if (!this.productForm) return;

      const form_input = this.productForm.querySelector('input[name="id"]');
      form_input.value = this.currentVariantId;
    }

    async getSectionContent() {
      const requestedVariantId = this.currentVariantId;
      fetch(`${this.datasetUrl}?variant=${requestedVariantId}&section_id=${this.sectionId}`)
        .then((response) => response.text())
        .then((responseText) => {
          if (this.currentVariantId !== requestedVariantId) return;

          const html = new DOMParser().parseFromString(responseText, 'text/html');

          this.updateSku(this.currentVariant?.sku);
          this.updateEAN(this.currentVariant?.barcode);
          if (html) {
            this.updatePrice(html);
            this.updateAddToCartButton(html);
            this.updateInventoryStatus(html);
          }
        });
    }

    fetchAvailability() {
      const requestedVariantId = this.currentVariantId;
      const availableLocationsUrl = `https://intersportapi.netlify.app/.netlify/functions/getAllInventoryLevels?variantId=${requestedVariantId}`;
      fetch(availableLocationsUrl)
        .then((response) => response.json())
        .then((data) => {
          if (this.currentVariantId !== requestedVariantId) return;

          this.updateAvailabilityContent(data);
          this.fetchReserveInStoreContent(data);
        });
    }

    fetchReserveInStoreContent(data) {
      const requestedVariantId = this.currentVariantId;
      const reserveInStoreUrl = `${this.datasetUrl}?variant=${requestedVariantId}`;
      fetch(reserveInStoreUrl)
        .then((response) => response.text())
        .then((responseText) => {
          if (this.currentVariantId !== requestedVariantId) return;

          const html = new DOMParser().parseFromString(responseText, 'text/html');
          if (html) {
            this.updateReserveInStoreContent(data, html);
          }
        })
        .finally(() => {
          this.productFormSection.classList.remove('section-loading');
        });
    }

    updateAvailabilityContent(data) {
      let stores = JSON.parse(JSON.stringify(data));
      const variantPartnerLocations = this.availablePartnerLocations.find((variant) => variant.sku == this.currentVariant.sku)?.stores || [];
      stores.push(...variantPartnerLocations);

      const storeAvailabilityWrapper = document.querySelector('.store-availability-wrapper');
      const storeAvailabilityCountEls = document.querySelectorAll('.store-availability-count span');
      const storeAvailabilityCountParentEls = document.querySelectorAll('.store-availability-count:not(.unavailable)');
      const storeAvailabilityUnavailableEls = document.querySelectorAll('.store-availability-count.unavailable');

      const drawerTrigger = storeAvailabilityWrapper.querySelector('[data-inventory-status]');
      const drawerContentEl = document.querySelector('[data-component-id="store-availability-drawer"] [data-store-availability-drawer-content]');
      const storeCount = stores.length;

      storeAvailabilityUnavailableEls.forEach((button) => {
        button.classList.add('hidden');
      });

      if (storeCount == 0) {
        storeAvailabilityCountParentEls.forEach((button) => {
          button.classList.add('hidden');
        });
        storeAvailabilityUnavailableEls.forEach((button) => {
          button.classList.remove('hidden');
        });
        drawerTrigger.removeAttribute('data-open-drawer');
      } else {
        storeAvailabilityCountParentEls.forEach((button) => {
          button.classList.remove('hidden');
        });
        storeAvailabilityUnavailableEls.forEach((button) => {
          button.classList.add('hidden');
        });
        drawerTrigger.setAttribute('data-open-drawer', 'store-availability-drawer');
      }

      if (storeAvailabilityCountEls.length > 0) {
        storeAvailabilityCountEls.forEach((button) => {
          button.textContent = storeCount;
        });
      }

      if (storeAvailabilityWrapper) {
        if (storeCount <= 0 && !this.currentVariant.available) {
          storeAvailabilityWrapper.classList.add('hidden');
        } else {
          storeAvailabilityWrapper.classList.remove('hidden');
        }
      }

      if (drawerContentEl && storeCount > 0) {
        // get direct child li element and fill information and append
        const drawerContent = stores.map((store) => {
          return `
            <li class="bg-background text-foreground rounded-md p-4 space-y-2">
              <h5>${store.name}</h5>
              ${store.opening_hours
              ? `
                    <div class="flex">
                      <svg class="text-foreground inline" aria-hidden="true" viewBox="0 0 16 16">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M13 5.52901L6.41426 12L3 8.64522L4.39172 7.11621L6.41426 9.10352L11.6083 4L13 5.52901Z" fill="currentColor"></path>
                      </svg>
                      <div class="flex flex-col gap-y-1">
                        <p class="text-1-regular">${window.storeAvailabilityStrings.pickupAvailable}</p>
                        <div class="whitespace-pre-line">${store.opening_hours}</div>
                      </div>
                    </div>
                  `
              : ''
            }
              <div class="flex">
                <svg class="text-foreground inline" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path d="M12.3897 19.2642C12.2483 19.4044 12.1176 19.5311 12 19.6433C11.8824 19.5311 11.7517 19.4043 11.6104 19.2642C10.9741 18.6333 10.1275 17.7366 9.28342 16.6726C7.55608 14.4953 6 11.8153 6 9.35294C6 6.45517 8.29155 4 12 4C15.7085 4 18 6.45516 18 9.35294C18 11.8153 16.4439 14.4953 14.7166 16.6726C13.8725 17.7366 13.0259 18.6333 12.3897 19.2642Z" stroke="currentColor" stroke-width="2"></path>
                  <circle cx="12" cy="10" r="2" fill="currentColor"></circle>
                </svg>
                <address class="not-italic">
                  ${store.address.address1 ? `<p>${store.address.address1}${store.address.address2 ? `, ${store.address.address2}` : ''}</p>` : ''}
                  ${store.address.zip || store.address.city ? `<p>${store.address.zip} ${store.address.city}</p>` : ''}
                  ${store.address.phone ? `<p>${store.address.phone}</p>` : ''}
                </address>
              </div>
            </li>
          `;
        });
        drawerContentEl.innerHTML = drawerContent.join('');
      } else {
        drawerContentEl.innerHTML = '';
      }
    }

    updateReserveInStoreContent(data, html) {
      // get stores that has emails and reserve_item is true
      const variantPartnerLocations = this.availablePartnerLocations.find((variant) => variant.sku == this.currentVariant.sku)?.stores || [];
      data.push(...variantPartnerLocations);

      const stores = data.filter((store) => store.email && store.reserve_item === 'true');

      const storeAvailabilityWrapper = document.querySelector('.store-availability-wrapper');
      const reserveInStoreButton = storeAvailabilityWrapper?.querySelector('[data-open-drawer="reserve-in-store-drawer"]');
      const reserveDrawerEl = document.querySelector('[data-component-id="reserve-in-store-drawer"]');
      if (!reserveDrawerEl) return;
      const reserveDrawer = html.querySelector('[data-component-id="reserve-in-store-drawer"]');
      if (!reserveDrawer) return;

      if (!stores) {
        if (reserveInStoreButton) reserveInStoreButton.classList.add('!hidden');
        return;
      }
      const storeCount = stores.length;

      // update store options
      const storesOptionsEl = reserveDrawerEl.querySelector('#FormReserveInStore [name="store"]');
      const placeholderOption = `<option value="" disabled selected>${window.storeAvailabilityStrings.selectStore}</option>`;
      if (storesOptionsEl) {
        storesOptionsEl.innerHTML = placeholderOption;
      }
      if (reserveInStoreButton && storeCount > 0) {
        if (reserveInStoreButton) reserveInStoreButton.classList.remove('!hidden');
        const sortedStores = stores.sort((a, b) => a.name.localeCompare(b.name));
        const storesOptions = sortedStores
          .map((store) => {
            return `<option value="${store.name}" email="${store.email}">${store.name}</option>`;
          })
          .join('');
        if (storesOptionsEl) {
          storesOptionsEl.insertAdjacentHTML('beforeend', storesOptions);
        }
      } else {
        if (reserveInStoreButton) reserveInStoreButton.classList.add('!hidden');
      }

      // update form data
      const formData = reserveDrawer.querySelector('#FormReserveInStore [data-reactive]');
      const formDataTarget = reserveDrawerEl.querySelector('#FormReserveInStore [data-reactive]');
      if (formData && formDataTarget) {
        formDataTarget.innerHTML = formData.innerHTML;
      }
    }

    updatePrice(html) {
      const id = `price-${this.sectionId}`;
      const oldPrice = document.getElementById(id);
      const newPrice = html.getElementById(id);
      if (oldPrice && newPrice) oldPrice.innerHTML = newPrice.innerHTML;
    }

    updateAddToCartButton(html) {
      const productForm = this.productForm;
      if (!productForm) return;

      const addButtonUpdated = html.getElementById(`Add-to-cart-${this.sectionId}`);
      const disable = addButtonUpdated?.hasAttribute('disabled') ?? true;

      const addButton = productForm.querySelector('[name="add"]');
      const addButtonText = addButton.querySelector('.add-to-cart-text');

      if (disable) {
        if (addButton) addButton.setAttribute('disabled', '');
        if (addButtonText) addButtonText.textContent = window.variantStrings.soldOut;
      } else {
        if (addButton) addButton.removeAttribute('disabled');
        if (addButtonText) addButtonText.textContent = window.variantStrings.addToCart;
      }
    }

    updateSku(newSku) {
      const id = 'Sku-placeholder';
      const oldSku = document.getElementById(id);
      if (!oldSku || !newSku) return;

      const skuValueEl = oldSku.querySelector('[data-value]');

      if (skuValueEl) skuValueEl.textContent = newSku;
    }

    updateEAN(newEAN) {
      if (!newEAN) return;

      const querySelector = '[data-product-ean]';
      const eanEL = document.querySelectorAll(querySelector);
      if (eanEL && eanEL.length > 0) {
        eanEL.forEach((el) => {
          el.textContent = newEAN;
        });
      }
    }

    updateInventoryStatus(html) {
      const id = `Inventory-status-${this.sectionId}`;
      const oldInventory = document.getElementById(id);
      const newInventory = html.getElementById(id);
      const buyBtn = document.querySelector('[data-total-available]');
      if (oldInventory && newInventory) oldInventory.innerHTML = newInventory.innerHTML;
      if (buyBtn && newInventory) buyBtn.dataset.totalAvailable = newInventory.dataset.count;
      checkIfAllInstancesOfVariantAddedToCart();
    }

    updateMedia() {
      if (!this.currentVariant) return;
      if (!this.currentVariant.featured_media) return;
      if (!this.swiperEl) return;

      const activeSlide = this.swiperEl.querySelector(`[data-media-id="Slide-${this.currentVariant.featured_media.id}"]`);
      if (!activeSlide) return;
      const activeIndex = parseInt(activeSlide.getAttribute('data-swiper-slide-index'));
      const swiper = this.swiperEl.swiper;
      swiper.slideToLoop(activeIndex);
    }

    updateGalleryLabels() {
      if (!this.mediaGallery) return;

      this.soldOutLabels = this.mediaGallery.querySelectorAll('[data-sold-out-label]');
      this.salesOfferLabels = this.mediaGallery.querySelectorAll('[data-sales-offer-label]');

      if (this.currentVariant && this.currentVariant.available) {
        this.soldOutLabels.forEach((label) => {
          label.classList.add('hidden');
        });
      } else {
        this.soldOutLabels.forEach((label) => {
          label.classList.remove('hidden');
        });
      }

      if (this.currentVariant && this.currentVariant.compare_at_price) {
        this.salesOfferLabels.forEach((label) => {
          label.classList.remove('hidden');
        });
      } else {
        this.salesOfferLabels.forEach((label) => {
          label.classList.add('hidden');
        });
      }
    }
  }
  customElements.define('variant-selector', VariantSelector);
}
